import { __awaiter } from '../external_node_modules/tslib/tslib.es6.js';
import { writable } from '../external_node_modules/svelte/store/index.mjs.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';
import { getProductPrice } from './product_price.js';

const products = null;
const { subscribe, update } = writable(products);
function updateProduct(product, storefrontName) {
    return update((state) => {
        if (state === null || state.length === 0) {
            state = [product];
        }
        else {
            state.forEach(function (part, index) {
                if (this[index].id === product.id) {
                    this[index] = product;
                }
            }, state);
        }
        events.emit(EVENTS.PRODUCT_UPDATE, { product: product, storefrontName: storefrontName });
        return state;
    });
}
function updateProductVariablePriceByQuantity(product, quantity, storefrontName, platform) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!product.isVariablePriceProduct)
            return product;
        const variablePriceData = yield getProductPrice(product.externalProductId, quantity, platform, storefrontName);
        product.updateQuantity(quantity);
        product.updateVariableProductPrice(variablePriceData);
        updateProduct(product, storefrontName);
        return product;
    });
}

export { updateProduct, updateProductVariablePriceByQuantity };
//# sourceMappingURL=products.js.map
